<template>
    <el-dialog
        title="操作记录"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="show"
        :modal-append-to-body="false"
        :append-to-body="true"
        @close="close"
        width="80%"
        top="20px"
    >
        <div slot="title" style="display:flex;align-items:center;text-wrap: nowrap;overflow-x:auto;overflow-y:hidden;">
            <h4 style="margin-right:20px;">操作记录</h4>
            <div v-for="fItem in filter" :key="fItem.label" style="display:flex;align-items:center;margin-right:20px;">
                <div>
                    {{ fItem.label }}：
                </div>
                <div>
                    <el-input
                        v-if="fItem.type=='input'"
                        size="mini"
                        prefix-icon="el-icon-search"
                        :placeholder="'请输入'+fItem.label"
                        v-model.trim="fItem.value"
                        @change="filterChange"
                        clearable
                    />
                    <el-date-picker
                        v-if="fItem.type=='datetimerange'"
                        v-model="fItem.value"
                        :type="fItem.type"
                        start-placeholder="开始时间" end-placeholder="结束时间" size="mini"
                        @change="filterChange"
                        :value-format="fItem.valueFormat"
                    />
                    <el-select
                        v-if="fItem.type=='select'"
                        v-model="fItem.value"
                        size="mini" clearable multiple collapse-tags
                        :placeholder="'请选择'+fItem.label"
                        @change="filterChange"
                    >
                        <el-option v-for="item in fItem.options" :key="item.value" :value="item.value"/>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="content-container">
            <div class="table-container">
                <el-table
                    v-loading="tableConfig.isLoading"
                    :data="tableConfig.data"
                    :row-class-name="tableRowClassName"
                    ref="table" row-key="uniqKey"  height="99.8%" border
                >
                    <el-table-column label="序号" type="index" fixed="left" :width="80" :index="index=>tableConfig.limit*(tableConfig.page-1)+index+1"/>
                    <template v-for="item in tableConfig.cols">
                        <el-table-column
                            :key="item.field"
                            :label="item.name"
                            :prop="item.field"
                            :align="item.align||'center'"
                            :width="item.width"
                            :min-width="item.minWidth"
                        />
                    </template>
                </el-table>
            </div>
        </div>
        <div slot="footer" style="display:flex;justify-content:space-between;">
            <div>
                <el-pagination
                    background layout="prev,pager,next,jumper,sizes,total"
                    :total="tableConfig.total"
                    :current-page.sync="tableConfig.page"
                    :page-size.sync="tableConfig.limit"
                    :pager-count="5"
                    :page-sizes="[10,20,30,40,50]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    align="right"
                />
            </div>
            <div>
                <el-button @click="close" size="small">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { getUserInfo} from '@/utils/auth.js';
import {getAllLog} from '@/utils/log.js';
export default{
    name:'log-dialog',
    props:{
        show:{
            type:Boolean,default:false
        }
    },
    data(){
        return {
            filter:{
                time:{
                    value:[],label:'时间',type:'datetimerange',valueFormat:'timestamp'
                },
                actionType:{
                    value:[],label:'类型',type:'select',
                    options:[
                        {label:'上传',value:'上传'},
                        {label:'上传成功',value:'上传成功'},
                        {label:'上传失败',value:'上传失败'},
                        {label:'下载',value:'下载'},
                        {label:'下载失败',value:'下载失败'},
                        {label:'重新下载',value:'重新下载'},
                        {label:'删除离线任务',value:'删除离线任务'},
                    ],
                },
                content:{
                    value:'',label:'内容',type:'input'
                }
            },
            allLog:[],
            tableConfig:{
                data:[],isLoading:false,limit:10,page:1,total:0,
                cols:[
                    {name:'时间',field:'time',width:160},
                    {name:'类型',field:'actionType',width:80},
                    {name:'内容',field:'content',minWidth:200,align:'left'}
                ],
            },
        };
    },
    created(){
        let userStr=getUserInfo();
        if(userStr){
            let user=JSON.parse(userStr);
            if(user&&user.userId){
                getAllLog(user.userId).then(list=>{
                    (list||[]).sort((row1,row2)=>{
                        return row2.timestamp-row1.timestamp;
                    });
                    this.allLog=list;
                    this.getTableData();
                });
            }
        }
    },
    methods:{
        tableRowClassName({row,rowIndex}){
            switch(row.actionType){
                case '上传':
                    return '';
                case '上传成功':
                    return 'success-row';
                case '上传失败':
                    return 'warning-row';
                case '删除离线任务':
                    return 'danger-row';
                case '下载失败':
                    return 'warning-row';
                default:
                    return'';
            }
        },
        getTableData(){
            this.$set(this.tableConfig,'data',this.allLog);
            let {time,actionType,content}=this.filter;
            let {page,limit}=this.tableConfig;
            this.$set(this.tableConfig,'isLoading',true);
            let filterLog=this.allLog.filter(row=>{
                let timeV=true;
                if(time.value&&time.value.length){
                    let [startTimestamp,endTimestamp]=time.value;
                    let {timestamp}=row;
                    timeV=timestamp>=startTimestamp&&timestamp<=endTimestamp;
                }
                let actionTypeV=true;
                if(actionType.value&&actionType.value.length){
                    actionTypeV=actionType.value.includes(row.actionType);
                }
                let contentV=true;
                if(content.value){
                    contentV=row.content.includes(content.value);
                }
                return timeV&&actionTypeV&&contentV;
            });
            let start=limit*(page-1);
            let end=start+limit;
            this.$set(this.tableConfig,'total',filterLog.length);
            this.$set(this.tableConfig,'data',filterLog.slice(start,end));
            this.$set(this.tableConfig,'isLoading',false);
        },
        filterChange(){
            this.$set(this.tableConfig,'page',1);
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.getTableData();
        },
        handleSizeChange(size){
            this.$set(this.tableConfig,'page',1);
            this.getTableData();
        },
        close(){
            this.$emit('update:show',false);
        },
    },

}
</script>

<style lang="scss" scoped>
::v-deep .el-table{
    .success-row{
        background: #f0f9eb;
    }
    .warning-row{
        background: rgba(255, 0, 0,0.05);
    }
    .danger-row{
        background:#f7b5b5;
    }
}
.content-container{
    height:76vh;display:flex;flex-direction:column;
    .table-container{
        flex:1 1 auto;height:100px;
    }
}
</style>